/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import { string, arrayOf, shape } from "prop-types";
// eslint-disable-next-line import/no-cycle
import { SocialFollowButtons as SocialFollowButtonsComponent } from "../../sharedComponents/SocialFollowButtons";
import * as styles from "./SocialFollowButtons.module.scss";

const SocialFollowButtons = ({
	facebookPageLink,
	instagramPageLink,
	twitterPageLink,
	pinterestPageLink,
	youTubePageLink,
	tags,
}) => (
	<SocialFollowButtonsComponent
		facebookPageLink={facebookPageLink}
		instagramPageLink={instagramPageLink}
		twitterPageLink={twitterPageLink}
		pinterestPageLink={pinterestPageLink}
		youTubePageLink={youTubePageLink}
		tags={tags}
		styles={styles}
	/>
);

SocialFollowButtons.propTypes = {
	facebookPageLink: string,
	instagramPageLink: string,
	twitterPageLink: string,
	pinterestPageLink: string,
	youTubePageLink: string,
	tags: arrayOf(
		shape({
			to: string,
			target: string,
			text: string,
		})
	),
};
SocialFollowButtons.defaultProps = {
	facebookPageLink: null,
	instagramPageLink: null,
	twitterPageLink: null,
	pinterestPageLink: null,
	youTubePageLink: null,
	tags: null,
};

export default SocialFollowButtons;
export { SocialFollowButtons };
